var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"node"},[_c('div',[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"node-description"},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }